import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { CatalogsRoutingModule } from './catalogs-routing.module';
import { CatalogPreviewDialogComponent } from './components/catalog-preview-dialog/catalog-preview-dialog.component';
import { ProductFormDialogComponent } from './components/product-form-dialog/product-form-dialog.component';
import { CreateEditCatalogComponent } from './pages/create-edit-catalog/create-edit-catalog.component';
import { ListCatalogsComponent } from './pages/list-catalogs/list-catalogs.component';

@NgModule({
  declarations: [
    ListCatalogsComponent,
    CreateEditCatalogComponent,
    ProductFormDialogComponent,
    CatalogPreviewDialogComponent,
  ],
  imports: [
    CommonModule,
    CatalogsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    CoreModule,
    PrimeNgModule,
    ComponentsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class CatalogsModule {}
